<div class="right-panel">
  <div class="right-panel__body">
    <!-- Toolbar: keresés + gombok -->
    @if (!moveOnly) {
    <div class="right-panel__toolbar">
      <div class="right-panel__search">
        <app-search-bar
          [showFileBrowserButton]="showFileBrowserButton"
          [fileBrowserActive]="fileBrowserActive"
          (search)="executeSearch($event)"
          (fileBrowserToggle)="fileBrowserToggle.emit()"
        />
      </div>
      <p-menu #newMenu [model]="newMenuItems" [popup]="true" appendTo="body" />
      <div class="right-panel__toolbar-actions">
        <button class="right-panel__new-btn" (click)="newMenu.toggle($event)">
          <span class="right-panel__new-btn-plus">+</span>
          <span>Új</span>
        </button>
        <input #fileInput type="file" multiple hidden [attr.accept]="filesystemFilter.acceptAttribute()" (change)="onFileSelected($event)" />
        <input
          #folderInput
          type="file"
          webkitdirectory
          directory
          hidden
          (change)="onFileSelected($event)"
        />

         @if (isGridEnabled) {
        <div class="right-panel__view-toggle">
          <p-selectButton
            name="viewMode"
            [options]="viewOptions"
            [(ngModel)]="viewMode"
            optionValue="value"
            [allowEmpty]="false"
          >
            <ng-template let-item pTemplate="item">
              @if (item.icon === 'list') {
                <app-svg-icon name="list-view" [size]="16" />
              } @else {
                <app-svg-icon name="grid-view" [size]="16" />
              }
            </ng-template>
          </p-selectButton>
        </div>
      }
      </div>
    </div>
    } @else {
    <div class="right-panel__toolbar">
      <div class="right-panel__search">
        <app-search-bar (search)="executeSearch($event)" />
      </div>
    </div>
    }

    <!-- Breadcrumbs + nézet váltó -->
    <div class="right-panel__breadcrumb-bar">
      <div class="right-panel__breadcrumbs">
        <p-breadcrumb
          [model]="breadcrumbItems"
          [home]="homeItem"
          styleClass="right-panel__breadcrumb-comp"
        />
      </div>

    </div>

    <div class="right-panel__content-area">
      <div class="right-panel__files">
      <!-- Fájl listanézet / Grid nézet -->
      @if (viewMode === 'list') {
        <app-file-list-view
          [files]="files"
          [(selectedFiles)]="selectedFiles"
          [highlightedFileName]="highlightedFileName()"
          [hasSelectedCategory]="hasSelectedCategory"
          [linkStatusMap]="fileLinkStatusMap"
          (navigateToFolder)="navigateToFolder($event)"
          (linkSelected)="linkSelected()"
          (showLinks)="showFileLinks($event)"
          (deleteSelected)="deleteSelected()"
          (deleteItem)="deleteItem($event)"
          (previewFile)="previewFile($event)"
          (downloadFile)="downloadFile($event)"
          (renameFile)="renameFromList($event.file, $event.newName)"
          (fileDragStart)="onFileDragStart($event.event, $event.file)"
        />
      } @else {
        <app-file-grid-view
          [folders]="folders"
          [filesList]="filesList"
          [highlightedFileName]="highlightedFileName()"
          [(selectedFiles)]="selectedFiles"
          (navigateToFolder)="navigateToFolder($event)"
          (deleteSelected)="deleteSelected()"
          (previewFile)="previewFile($event)"
          (downloadFile)="downloadFile($event)"
          (deleteItem)="deleteItem($event)"
          (fileDragStart)="onFileDragStart($event.event, $event.file)"
          (showLinks)="showFileLinks($event)"
        />
      }

      @if (isDragOver && !uiState.isInternalDragging()) {
        <div class="right-panel__drop-overlay">
          <div class="right-panel__drop-overlay-content">
            <div class="right-panel__drop-overlay-icon-circle">
              <app-svg-icon name="upload" [size]="28" />
            </div>
            <p class="right-panel__drop-overlay-text">Feltöltéshez húzza ide a fájlt.</p>
            <p class="right-panel__drop-overlay-subtext">(Maximum: 2.00 Mb)</p>
          </div>
        </div>
      }

      @if (isDragOver && canAcceptMove) {
        <div class="right-panel__drop-overlay">
          <div class="right-panel__drop-overlay-content">
            <div class="right-panel__drop-overlay-icon-circle">
              <i class="pi pi-arrow-right-arrow-left right-panel__drop-overlay-move-icon"></i>
            </div>
            <p class="right-panel__drop-overlay-text">Áthelyezés ebbe a mappába.</p>
          </div>
        </div>
      }
      </div>

      <!-- Beépített előnézet (iframe / kép) -->
      @if (inlinePreviewType) {
        <div class="right-panel__preview">
          <div class="right-panel__preview-header">
            <span class="right-panel__preview-title" [title]="inlinePreviewName">{{ inlinePreviewName }}</span>
            <button
              type="button"
              class="right-panel__preview-close"
              aria-label="Előnézet bezárása"
              (click)="closeInlinePreview()"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
          <div class="right-panel__preview-body">
            @if (inlinePreviewType === 'pdf') {
              <iframe
                class="right-panel__preview-frame"
                [src]="inlinePreviewSafeUrl"
                title="Fájl előnézet"
              ></iframe>
            } @else {
              <img
                class="right-panel__preview-image"
                [src]="inlinePreviewRawUrl"
                [alt]="inlinePreviewName"
              />
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Action bar -->
  <app-file-action-bar [selectedFiles]="selectedFiles" />

  <!-- Footer -->
  <div class="right-panel__footer">
    <div class="right-panel__footer-left">
      <app-file-manager-quota [storage]="currentStorage" [refreshTrigger]="quotaRefreshTrigger" />
    </div>
    @if (!moveOnly) {
    <div class="right-panel__footer-right">
      <app-file-manager-plugins />
    </div>
    }
  </div>
</div>

<app-new-folder-dialog
  [(visible)]="showNewFolderDialog"
  (confirm)="createFolderFromDialog($event)"
/>

<app-delete-confirm-dialog
  [(visible)]="showDeleteDialog"
  [message]="deleteMessage"
  (confirm)="confirmDelete()"
/>

<app-linked-item-error-dialog
  [(visible)]="showLinkedItemErrorDialog"
  [message]="linkedItemErrorMessage"
/>

<app-file-links-dialog
  [(visible)]="showLinksDialog"
  [fileName]="linksDialogFileName"
  [links]="linksDialogLinks"
  [currentSourcemodelId]="currentSourcemodelId"
  (navigateToItem)="onNavigateToDocMatrixItem($event)"
/>

<!-- Upload Progress Panel (bottom-right accordion) -->
@if (showUploadDialog) {
  <div class="upload-panel" [class.upload-panel--collapsed]="!isUploadPanelExpanded">
    <div class="upload-panel__header" (click)="toggleUploadPanel()">
      <span class="upload-panel__title">{{ uploadPanelTitle }}</span>
      <div class="upload-panel__actions">
        <button
          type="button"
          class="upload-panel__icon-btn"
          [attr.aria-label]="isUploadPanelExpanded ? 'Összecsukás' : 'Kibontás'"
          (click)="toggleUploadPanel(); $event.stopPropagation()"
        >
          <i [class]="isUploadPanelExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
        </button>
        @if (!isUploading) {
          <button
            type="button"
            class="upload-panel__icon-btn"
            aria-label="Bezárás"
            (click)="closeUploadPanel(); $event.stopPropagation()"
          >
            <i class="pi pi-times"></i>
          </button>
        }
      </div>
    </div>
    @if (isUploadPanelExpanded) {
      <div class="upload-panel__body">
        @if (isUploading) {
          <p-progressBar [value]="uploadProgress" [showValue]="true" />
        }
        @if (allUploads().length > 0) {
          <app-file-upload-status [uploads]="allUploads()" />
        }
      </div>
    }
  </div>
}

<app-file-preview-dialog
  [(visible)]="showPreviewDialog"
  [fileName]="previewFileName"
  [mimeType]="previewMimeType"
  [url]="previewUrl"
/>
